// tslint:disable
export var DebitCardMapStatus;
(function (DebitCardMapStatus) {
    // Pending Order
    DebitCardMapStatus[DebitCardMapStatus["PENDING"] = 1] = "PENDING";
    // Active
    DebitCardMapStatus[DebitCardMapStatus["ACTIVE"] = 2] = "ACTIVE";
    // Inactive
    DebitCardMapStatus[DebitCardMapStatus["INACTIVE"] = 3] = "INACTIVE";
})(DebitCardMapStatus || (DebitCardMapStatus = {}));
//# sourceMappingURL=DebitCardMapStatus.js.map